<template>
    <div ref="container" :class="customClass"></div>
</template>

<script>
import Croppie from "croppie";

export default {
    name: "VueCroppie",
    props: {
        boundary: {
            type: Object,
            default: () => ({ width: 300, height: 300 })
        },
        viewport: {
            type: Object,
            default: () => ({ width: 200, height: 200, type: "square" })
        },
        customClass: { type: String, default: "" },
        enableExif: { type: Boolean, default: false },
        enableOrientation: { type: Boolean, default: true },
        enableResize: { type: Boolean, default: true },
        enableZoom: { type: Boolean, default: true },
        enforceBoundary: { type: Boolean, default: true },
        mouseWheelZoom: { type: [Boolean, String], default: true },
        showZoomer: { type: Boolean, default: true }
    },
    emits: ["update"],
    data() {
        return { croppieInstance: null };
    },
    mounted() {
        this.croppieInstance = new Croppie(this.$refs.container, {
            boundary: this.boundary,
            viewport: this.viewport,
            customClass: this.customClass,
            enableExif: this.enableExif,
            enableOrientation: this.enableOrientation,
            enableResize: this.enableResize,
            enableZoom: this.enableZoom,
            enforceBoundary: this.enforceBoundary,
            mouseWheelZoom: this.mouseWheelZoom,
            showZoomer: this.showZoomer
        });
        this.croppieInstance.element.addEventListener("update", (e) => {
            this.$emit("update", e.detail);
        });
    },
    beforeUnmount() {
        if (this.croppieInstance) {
            this.croppieInstance.destroy();
            this.croppieInstance = null;
        }
    },
    methods: {
        bind(options) {
            return this.croppieInstance
                ? this.croppieInstance.bind(options)
                : Promise.resolve();
        },
        rotate(angle) {
            if (this.croppieInstance) this.croppieInstance.rotate(angle);
        },
        result(options, callback) {
            if (!this.croppieInstance) return Promise.resolve(null);
            const p = this.croppieInstance.result(options);
            if (callback) p.then(callback);
            return p;
        },
        refresh() {
            if (this.croppieInstance) this.croppieInstance.refresh();
        },
        destroy() {
            if (this.croppieInstance) {
                this.croppieInstance.destroy();
                this.croppieInstance = null;
            }
        }
    }
};
</script>
